module.exports = __webpack_public_path__ + "static/media/value.fc86e7cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/assets/images/agencyMonitor/value.png
// module id = 997
// module chunks = 29